import { useCallback, useRef, useState, type ComponentProps } from "react";
import { useOutsideDismiss } from "./useOutsideDismiss";
import { useDropdownOverlay } from "./useDropdownOverlay";

/** Transient action menus; ordinary expandable page sections remain persistent. */
export function DropdownDisclosure({ children, overlay = false, ...props }: Omit<ComponentProps<"details">, "open"> & { overlay?: boolean }) {
  const ref = useRef<HTMLDetailsElement>(null);
  const [open, setOpen] = useState(false);
  const close = useCallback(() => { if (ref.current) ref.current.open = false; }, []);
  useOutsideDismiss(ref, open, close);
  useDropdownOverlay(ref, open && overlay);
  return <details {...props} ref={ref} data-dropdown onToggle={event => {
    setOpen(event.currentTarget.open);
    props.onToggle?.(event);
  }} onKeyDown={event => {
    props.onKeyDown?.(event);
    if (event.key === "Escape" && !event.defaultPrevented && ref.current?.open) {
      event.preventDefault();
      event.stopPropagation();
      close();
      ref.current.querySelector<HTMLElement>(":scope > summary")?.focus();
    }
  }}>{children}</details>;
}
